export default {
  green: 'green',
  'dark-gray': 'dark-gray',
};
